import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraIctServiceAssessment } from '../../models/doraIctServiceAssessment.ts';

interface DoraIctServiceAssessmentState {
  ictServiceAssessments: DoraIctServiceAssessment[];
  selectedIctServiceAssessment: DoraIctServiceAssessment | null;
}

const initialState: DoraIctServiceAssessmentState = {
  ictServiceAssessments: [],
  selectedIctServiceAssessment: null,
};

const doraIctServiceAssessmentSlice = createSlice({
  name: 'doraIctServiceAssessment',
  initialState,
  reducers: {
    setIctServiceAssessments(state, action: PayloadAction<DoraIctServiceAssessment[]>) {
      state.ictServiceAssessments = action.payload;
    },
    addIctServiceAssessment(state, action: PayloadAction<DoraIctServiceAssessment>) {
      state.ictServiceAssessments.push(action.payload);
    },
    updateIctServiceAssessment(state, action: PayloadAction<DoraIctServiceAssessment>) {
      const index = state.ictServiceAssessments.findIndex(assessment => assessment.id === action.payload.id);
      if (index !== -1) state.ictServiceAssessments[index] = action.payload;
    },
    removeIctServiceAssessment(state, action: PayloadAction<number>) {
      state.ictServiceAssessments = state.ictServiceAssessments.filter(assessment => assessment.id !== action.payload);
    },
    setSelectedIctServiceAssessment(state, action: PayloadAction<DoraIctServiceAssessment | null>) {
      state.selectedIctServiceAssessment = action.payload;
    },
  },
});

export const {
  setIctServiceAssessments,
  addIctServiceAssessment,
  updateIctServiceAssessment,
  removeIctServiceAssessment,
  setSelectedIctServiceAssessment,
} = doraIctServiceAssessmentSlice.actions;

export const selectIctServiceAssessments = (state: RootState) => state.doraIctServiceAssessment.ictServiceAssessments;
export const selectSelectedIctServiceAssessment = (state: RootState) => state.doraIctServiceAssessment.selectedIctServiceAssessment;

export default doraIctServiceAssessmentSlice.reducer;
